import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaFilm,
  FaStar,
  FaRocket,
  FaMobileAlt,
  FaCheckCircle,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const DocumentaryVideoProductionInBurDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Documentary Video Production in Bur Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Capture Authentic Stories</Subheading>}
        heading={
          <Heading>
            Documentary Video <span tw="text-primary-500">Production</span> in
            Bur Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we excel in documentary video production in **Bur
            Dubai**, creating authentic, impactful films that tell compelling
            stories for brands, communities, and causes.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1551966775-a4ddc8df052b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Professional camera setup
          "https://images.unsplash.com/photo-1485846234645-a62644f84728?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Cinematic storytelling
          "https://images.unsplash.com/photo-1574717024653-61fd2cf4d44d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Director on set
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Start Your Documentary"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Authentic Documentaries in Bur Dubai"
        description="We craft films that inspire and inform."
        cards={[
          {
            icon: <FaFilm color="#ff5464" size={40} />,
            title: "Powerful Storytelling",
            description: "Narratives that resonate with authenticity.",
          },
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Cinematic Quality",
            description: "High-definition visuals and immersive audio.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Timely Delivery",
            description: "Efficient production to meet your deadlines.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Platform Ready",
            description: "Optimized for festivals, websites, and social media.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted by Clients",
            description: "Bur Dubai’s choice for documentary films.",
          },
          {
            icon: <FaCheckCircle color="#ff5464" size={40} />,
            title: "Custom Solutions",
            description: "Tailored for brands, causes, or personal stories.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Documentary Production Process"
        description={
          <Description>
            We create meaningful documentaries with a refined process:
            <ul tw="mt-4 list-disc pl-6">
              <li>Consultation: Understand your story and objectives.</li>
              <li>Research: Dive deep into the subject for authenticity.</li>
              <li>Filming: Capture real moments with professional gear.</li>
              <li>Editing: Craft a narrative with music and visuals.</li>
              <li>Delivery: Provide films ready to share or screen.</li>
              <li>Support: Offer revisions to perfect your vision.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1540655037529-dec987208707?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Filmmaking equipment
          "https://images.unsplash.com/photo-1633080413606-2c21b92bd7b8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Video editing process
          "https://images.unsplash.com/photo-1470790376778-a9e6b6a93fa3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Creative production setup
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Documentary Wins in Bur Dubai"
        description="Our films have moved audiences."
        cards={[
          {
            icon: <FaFilm color="#ff5464" size={40} />,
            title: "Emotional Impact",
            description: "Stories that inspired action and awareness.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Acclaim",
            description: "95% satisfaction from Bur Dubai clients.",
          },
          {
            icon: <FaCheckCircle color="#ff5464" size={40} />,
            title: "Broad Reach",
            description: "Films screened at festivals and online.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Tell Your Story?</Subheading>}
        heading="Documentary Video Production in Bur Dubai"
        description={
          <Description>
            Partner with MilaajBrandset for expert documentary video production
            in Bur Dubai. Get authentic, impactful films to share your
            story—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Authentic documentary moment
          "https://images.unsplash.com/photo-1560474451-dc18a9c78a5c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Professional camera work
          "https://images.unsplash.com/photo-1517799094725-e3453440724e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Documentary filming scene
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
